/*
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-05-12 15:28:04
 * @LastEditors: luckymiaow
 * @LastEditTime: 2022-07-13 09:19:50
 */
import type { SelectProps } from 'ant-design-vue';
import type { FormConfig } from '../form/types';

type ISelectPropsExcludeValue = Omit<SelectProps, 'value' | 'fieldNames'>;

export class FieldNames {
  true = '是';
  false = '否';
}

export interface IBooleanSelect extends ISelectPropsExcludeValue, FormConfig {
  fieldNames?: FieldNames;
  value?: boolean;
}
